export const dialogTitleStyles = {
    fontWeight: 'bold',
    fontSize: '1.75rem',
    color: '#333',
    textAlign: 'center',
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textTransform: 'capitalize',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    marginLeft: '3px',
};

export const dialogContentStyles = {
    padding: '24px',
    backgroundColor: '#f4f6f8',
};

export const alertStyles = {
    marginTop: '16px',
};

export const iconButtonStyles = {
    color: '#808080',
    fontSize: '1.5rem',
};